module.exports = __webpack_public_path__ + "5619101c575c1845396afe179cee19e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/create_workshop@2x.jpg
// module id = 646
// module chunks = 0